export default __webpack_public_path__ + "static/media/ai_color_detection.9ccde7bf.svg";